<template>

<div class="card">
  <!-- Card image -->
 

  <!-- Card content -->
  <div class="card-body">

    <!-- Title -->
    <div class="row">
      <div class="col-md-11">
           <h6 class="card-title">
        <a>{{ pergunta.ordemExibicao }} ) {{ pergunta.titulo }}</a>
        <span v-if="pergunta.obrigatoria" style="color:red;font-weigth:bold">*</span>
      </h6>
      </div>
      <div class="col">
        <!-- <span class="badge badge-success" style="float:rigth"><i class="bi bi-check"></i></span> -->
      </div>
    </div>
 
    <!-- Text -->
    <p class="card-text" v-html="pergunta.descricao"></p>
    <div style="margin-left:0">
    <!--opcoes de resposta -->
      <div>
        <div>
            <input  
              @blur="validarResposta"
              @input="maskCpf(resposta)"
              :required="pergunta.obrigatoria"
              placeholder="Digite o CPF"
              class="form-control"
              type="text" id="txtcpf" name="txtcpf" v-model="resposta">
              <br>
              
        </div>

        <ul v-if="temErro" class="alert alert-sm alert-danger">
            <li :key="index"  v-for="(erro, index) in erros">
              {{`- ${erro}`}}
            </li>
          </ul>
      </div>
    </div>
  </div>

</div>

</template>

<script>
import repostaPerguntaMethodsMixin from './ResponderPerguntaMixin'
import perguntaService from '../../services/PerguntaService'
export default {
  mixins: [repostaPerguntaMethodsMixin],
  name: 'comp-pergunta-cpf',
  props: ['pergunta', 'permitirResponder'],
  data () {
    return {
      resposta: '',
      temErro: false,      
      erros:[]
    }
  },
  computed: {   
    botaoDesabilitado () {
      return this.resposta === '' || !this.permitirResponder
    },
    formulario(){
      return this.$store.state.formulario;
    }
  },
  methods: {
    responderPergunta () {
      const respostaFormulario = {
        pergunta: this.pergunta,
        resposta: this.resposta
      }
      this.$emit('responderPerguntaHandler', respostaFormulario)
    },
    maskCpf (value) {      
      this.resposta = value
        .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
        .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
    },
    async validarResposta () {
      
      const pergunta = this.pergunta;
      const {codigoTipoResposta, perguntaId,sessaoFormularioPerguntaId} = pergunta;
      const {formularioId} = this.formulario;
      // const perguntaId = this.pergunta.perguntaId
      const opcaoResposta = {opcaoResposta: {opcaoRespostaId: null, perguntaId, valor: this.resposta}, pergunta}
      
      const valorResposta = this.resposta;

      //remover o valor 
      this.removerTodasRespostasPergunta(sessaoFormularioPerguntaId);

      this.temErro = this.pergunta.obrigatoria && !this.resposta
      if (this.temErro) {
        this.erros.push('Você deve informar um número de cpf válido');
      } else {   
        const cpfValidacao = await perguntaService.getValidarResposta(formularioId, perguntaId, codigoTipoResposta,valorResposta)
        if (!cpfValidacao.estaValido) {
          this.temErro = true;          
          this.erros = [...cpfValidacao.erros]
        }else{
          this.responderPerguntaMixin(opcaoResposta)
        }
      }

      
    }
  },
  mounted () {
  }
}
</script>

<style>
ul{
    list-style: none;
  }
  ul li.alert{
    
  }
</style>



// WEBPACK FOOTER //
// src/components/PerguntasComponent/RespostaTipoCpf.vue